import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqItems = [
  { q: 'faq.q1', a: 'faq.a1' },
  { q: 'faq.q2', a: 'faq.a2' },
  { q: 'faq.q3', a: 'faq.a3' },
  { q: 'faq.q4', a: 'faq.a4' },
  { q: 'faq.q5', a: 'faq.a5' },
  { q: 'faq.q6', a: 'faq.a6' },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto w-full max-w-3xl px-4 py-16 md:px-6 md:py-24">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
            {t('nav.faq')}
          </span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            {t('faq.title')}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="mt-12 space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-xl border border-background-200/70 bg-white"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                >
                  <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                    {t(item.q)}
                  </span>
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-500">
                    <i
                      className={`ri-add-line text-sm transition-transform ${isOpen ? 'rotate-45' : ''}`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-6 pb-5 text-sm leading-relaxed text-foreground-600">
                    {t(item.a)}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}